import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Required = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M11.3269 8.35864C11.5201 7.68144 12.4799 7.68144 12.6731 8.35864L12.9599 9.36358C13.0636 9.72685 13.4368 9.94233 13.8032 9.85047L14.8169 9.59638C15.5 9.42515 15.9799 10.2563 15.4901 10.7623L14.7632 11.5131C14.5004 11.7845 14.5004 12.2155 14.7632 12.4869L15.4901 13.2377C15.9799 13.7437 15.5 14.5749 14.8169 14.4036L13.8032 14.1495C13.4368 14.0577 13.0636 14.2731 12.9599 14.6364L12.6731 15.6414C12.4799 16.3186 11.5201 16.3186 11.3269 15.6414L11.0401 14.6364C10.9364 14.2731 10.5632 14.0577 10.1968 14.1495L9.18305 14.4036C8.49995 14.5749 8.02009 13.7437 8.50993 13.2377L9.23683 12.4869C9.4996 12.2155 9.4996 11.7845 9.23683 11.5131L8.50993 10.7623C8.02009 10.2563 8.49995 9.42515 9.18305 9.59638L10.1968 9.85047C10.5632 9.94233 10.9364 9.72685 11.0401 9.36358L11.3269 8.35864Z"
      fill="currentColor"
    />
  </Icon>
);

export default Required;
